import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SectionList, View, Text, FlatList, Platform } from 'react-native';
import {
    Button,
    Background,
    SectionListHeader,
    sectionListStyles,
    ConfirmationModal,
    ActivityIndicator,
    withConfirmationModal
} from 'LocalGluons';
import { t } from 'Locale';
import { getDeviceName, Device } from 'DeviceUtils';
import { withStore } from 'Store';
import {
    checkScreenCapture,
    onScreenCaptureChange,
    startMirroringListener
} from 'react-native-prevent-screenshot-ios-android';
import MirroringPreventDialog from 'LocalGluons/components/PlayerContainer/components/MirroringPreventDialog';
import { DeviceListItem } from './components';
import { withAppErrorHandler } from '../../App/AppErrorHandlerContext/AppErrorHandlerContext';
import baseStyles from './DeviceManagement.jss';
import { TOP_BAR_HEIGHT, TOP_MARGIN_TABLET_OFFSET } from '../../Navigation/Menu/Menu.styles';
// @ts-ignore

class DeviceManagement extends Component {
    static propTypes = {
        appManager: PropTypes.shape({}).isRequired,
        setModalContent: PropTypes.func.isRequired,
        setError: PropTypes.func.isRequired,
        userData: PropTypes.shape({}).isRequired,
        navigation: PropTypes.shape({}).isRequired,
        setPlayerData: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            deviceToDelete: null,
            sections: [],
            remainingCount: 0,
            isMirroring: false
        };
    }

    componentDidMount() {
        this.fetchConfig();
        // this.checkAndHandleMirroring();
    }

    isMirrored = async () => {
        if (Platform.OS === 'android') {
            const data = await checkScreenCapture();
            if (data === 'Mirrored') {
                return true;
            }
            return false;
        }
        if (Platform.OS === 'ios') {
            const data = await checkScreenCapture();
            if (data) {
                return true;
            }
            return false;
        }
        return false;
    };

    // async checkAndHandleMirroring() {
    //     try {
    //         if (Platform.OS === 'android') {
    //             const data = await checkScreenCapture();
    //             this.setState({ isMirroring: data === 'Mirrored' });

    //             startMirroringListener((event) => {
    //                 this.setState({ isMirroring: event === 'DisplayAdded' });
    //             });

    //             if (this.state.isMirroring) {
    //                 this.props.setPlayerData(null);
    //             }
    //         } else if (Platform.OS === 'ios') {
    //             onScreenCaptureChange(({ isCaptured }) => {
    //                 this.setState({ isMirroring: isCaptured });
    //             });

    //             if (this.state.isMirroring) {
    //                 this.props.setPlayerData(null);
    //             }
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    deleteDevicePressed(device) {
        this.setState({ deviceToDelete: device });
        const { setModalContent } = this.props;
        setModalContent(
            <ConfirmationModal
                icon="warning_yellow_black"
                header={`${t('COMMON.DELETE_DEVICE_DELETE')} "${device.name}"`}
                message={t('COMMON.DELETE_DEVICE_MESSAGE')}
                confirmLabel={t('COMMON.DELETE_DEVICE_DELETE')}
                cancelLabel={t('COMMON.BTN_CANCEL')}
                onCancel={this.closeDeviceModal}
                onConfirm={this.deleteSelectedDevice}
            />
        );
    }

    async fetchConfig() {
        try {
            this.setState({ loaded: false });

            const { appManager, userData } = this.props;
            const received = await appManager.api.listDevices();
            const {
                thisDevice,
                smallScreenDevices,
                stbAndBigScreenDevices,
                remainingSmallScreenDevicesCount: remainingCount
            } = received;

            const items = [
                ...Object.values(smallScreenDevices),
                ...Object.values(stbAndBigScreenDevices)
            ];
            const isThisDeviceRegistered = thisDevice.registered;
            const thisDeviceName = isThisDeviceRegistered ? thisDevice.name : await getDeviceName();

            const newSections = [
                {
                    title: t('SETTINGS.MY_DEVICE').toUpperCase(),
                    data: [
                        {
                            name: thisDeviceName,
                            deviceId: userData.deviceId,
                            description: isThisDeviceRegistered
                                ? ''
                                : t('SETTINGS.DEVICE_NOT_REGISTERED'),
                            deviceType: thisDevice.category || 'OTHER'
                        }
                    ]
                }
            ];

            const otherDevices = items.map((device) => ({
                name: device.name,
                // Cannot remove STB device
                onPress: () => this.deleteDevicePressed(device),
                deviceType: device.category
            }));

            if (otherDevices.length > 0) {
                newSections.push({
                    title: t('SETTINGS.OTHER_DEVICES').toUpperCase(),
                    data: otherDevices
                });
            }

            this.setState({
                sections: newSections,
                loaded: true,
                remainingCount
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.setState({ loaded: true });
        }
    }

    closeDeviceModal = () => {
        this.setState({
            deviceToDelete: null
        });
        const { setModalContent } = this.props;
        setModalContent(null);
    };

    deleteSelectedDevice = async () => {
        const { deviceToDelete } = this.state;
        if (!deviceToDelete) {
            this.closeDeviceModal();
        } else {
            try {
                // Start loading
                this.setState({
                    loaded: false,
                    deviceToDelete: null
                });
                const { setModalContent } = this.props;
                setModalContent(null);

                if (deviceToDelete) {
                    const { appManager } = this.props;
                    await appManager.api.deleteDevice(deviceToDelete.id);
                }

                this.fetchConfig();
            } catch (error) {
                const { setError } = this.props;
                setError({ error, screenId: 'deviceManagement' });
                this.setState({ loaded: true });
            }
        }
    };

    render() {
        const { navigation, route, setPlayerData, setModalContent } = this.props;
        const { loaded, sections, remainingCount } = this.state;
        const playerData = route?.params?.playerData;
        const isSetting = navigation
            .getState()
            .history?.[navigation.getState().history.length - 1]?.key?.includes('setting');

        return (
            <Background>
                {loaded ? (
                    <>
                        <FlatList
                            style={
                                !isSetting && !Device.isWeb
                                    ? {
                                          marginTop: -TOP_BAR_HEIGHT + TOP_MARGIN_TABLET_OFFSET
                                      }
                                    : playerData === undefined
                                      ? { marginTop: -23 }
                                      : baseStyles.outerContainer
                            }
                            data={sections}
                            keyExtractor={(item, index) => item + index}
                            renderItem={({ item }) => (
                                <SectionList
                                    style={baseStyles.sectionList}
                                    stickySectionHeadersEnabled={false}
                                    renderItem={({ item, index }) => (
                                        <View style={baseStyles.sectionListItemContainer}>
                                            <DeviceListItem
                                                name={item.name}
                                                description={item.description}
                                                onPress={item.onPress}
                                                testID={`device_${index}}`}
                                                deviceType={item.deviceType}
                                                deviceId={item.deviceId}
                                                sectionContainer={baseStyles.sectionText}
                                            />
                                        </View>
                                    )}
                                    renderSectionHeader={({ section: { title } }) => (
                                        <View style={baseStyles.sectionHeader}>
                                            <SectionListHeader
                                                title={title}
                                                itemDividerStyle={
                                                    Device.isWeb ? { marginRight: 10 } : {}
                                                }
                                            />
                                        </View>
                                    )}
                                    sections={[item]}
                                    keyExtractor={(item, index) => item + index}
                                />
                            )}
                        />
                        {Boolean(playerData) && remainingCount >= 1 && (
                            <View
                                style={[baseStyles.playAssetContainer, sectionListStyles.container]}
                            >
                                <Text style={[sectionListStyles.itemName, { textAlign: 'center' }]}>
                                    {t('SETTINGS.REGISTER_DEVICE_TXT')}
                                </Text>
                                <View style={baseStyles.button}>
                                    <Button
                                        title={t('COMMON.START_LIVE_TV')}
                                        onPress={async () => {
                                            navigation.goBack();
                                            const isMirrored = await this.isMirrored();
                                            if (isMirrored) {
                                                setModalContent(
                                                    <MirroringPreventDialog
                                                        setModalContent={setModalContent}
                                                    />
                                                );
                                            } else {
                                                setPlayerData(playerData);
                                            }
                                        }}
                                    />
                                </View>
                            </View>
                        )}
                    </>
                ) : (
                    <ActivityIndicator />
                )}
            </Background>
        );
    }
}

export default withConfirmationModal(withAppErrorHandler(withStore(DeviceManagement)));
